import { useMutation, useQuery, useQueryClient } from "react-query";
import { getItem, getPagedItems, PagedList, postAny, update } from "../Api";
import { Quote } from "../Quote/Quote";
import { EventSlot, EventSlotQueryParams, ScheduleQuoteForm } from "./EventSlot";

export async function getQuoteEventSlots(
  queryParams: EventSlotQueryParams,
  isEnabled: boolean
): Promise<PagedList<EventSlot>> {
  if (!isEnabled) {
    return {
      items: [],
      total: 0,
      page: 1,
      totalPages: 0
    };
  }
  const { quoteId, page, pageSize } = queryParams;

  return getPagedItems<EventSlot>(`store/quoteslot/${quoteId}/available`, page, pageSize);
}

export async function scheduleQuoteEvent(form: ScheduleQuoteForm): Promise<Quote> {
  return postAny<null>(`store/quoteslot/${form.quoteId}/schedule/${form.eventSlotId}`, null);
}

export async function releaseQuoteEvent(quoteId: string): Promise<Quote> {
  return update<null>(`store/quoteslot/${quoteId}/release/true`, null);
}

export async function getEventSlot(eventSlotId?: string | null): Promise<EventSlot | null> {
  if (!eventSlotId) {
    return null;
  }

  return getItem<EventSlot>(`assessments/eventslot`, eventSlotId);
}

const QuoteEventSlots = "quote-event-slots";
const QuoteEventSlot = "quote-event-slot";

export const useQuoteEventSlots = (query: EventSlotQueryParams, isEnabled: boolean) =>
  useQuery([QuoteEventSlots, query], () => getQuoteEventSlots(query, isEnabled), {
    keepPreviousData: true,
    staleTime: 10000,
    refetchOnWindowFocus: false
  });

export const useGetEventSlot = (eventSlotId?: string | null) =>
  useQuery([QuoteEventSlot, eventSlotId], () => getEventSlot(eventSlotId), {
    refetchOnWindowFocus: false
  });

export const useScheduleQuote = () => {
  const clientQuery = useQueryClient();
  return useMutation(scheduleQuoteEvent, {
    onSuccess: () => {
      clientQuery.invalidateQueries([QuoteEventSlots]);
      clientQuery.invalidateQueries([QuoteEventSlot]);
    }
  });
};
